"use client";

import { useEffect, useState } from "react";

// The same key the old sidebar wrote, so a preference set before the move
// still holds. "true" means the panel is hidden.
const PANEL_HIDDEN_KEY = "salesably-sidebar-collapsed";

/** Whether the side nav panel is open, read after mount so the server and client agree. */
export function usePanelPreference() {
  const [open, setOpen] = useState(true);
  useEffect(() => {
    try {
      setOpen(window.localStorage.getItem(PANEL_HIDDEN_KEY) !== "true");
    } catch {
      // Storage blocked: the panel simply starts open.
    }
  }, []);
  const persist = (next) => {
    setOpen(next);
    try {
      window.localStorage.setItem(PANEL_HIDDEN_KEY, String(!next));
    } catch {
      // Same: nothing to do.
    }
  };
  return [open, persist];
}

